import { getCatalogId, ICoreContext } from '@msdyn365-commerce/core-internal';
import { getProductFringesAsync } from '../proxy/DataActionExtension.g';
import { IContext } from '@msdyn365-commerce/retail-proxy';
import { IProductFringe, IProductTimeSlot } from '../proxy/DataServiceEntities.g';

export interface IFringesRequestParams {
    itemId: string;
    catalogId: number;
    customerId: string;
}

export const getFringesRequestParams = (itemId: string, context: ICoreContext): IFringesRequestParams => {
    const catalogId = getCatalogId(context.request);
    const customerId = context?.actionContext?.requestContext?.user?.customerAccountNumber ?? '';

    return {
        itemId,
        catalogId,
        customerId
    };
};

export const loadProductFringes = async (context: IContext, params: IFringesRequestParams): Promise<IProductFringe[]> => {
    return getProductFringesAsync(context, params.itemId, params.catalogId, params.customerId);
};

export const getEmptySchedulingState = () => ({
    availableEvents: undefined,
    selectedEvent: undefined,
    selectedTimeSlot: undefined,
    availableFringes: undefined,
    selectedFringe: undefined,
    timeSlotErrorMessage: undefined,
    eventErrorMessage: undefined,
    fringeErrorMessage: undefined
});

export const buildFringesLoadedState = (availableFringes?: IProductFringe[]) => ({
    ...getEmptySchedulingState(),
    availableFringes
});

export const buildEventsLoadedState = (availableEvents?: IProductTimeSlot[]) => ({
    ...getEmptySchedulingState(),
    availableEvents
});
